export default __webpack_public_path__ + "static/media/paranoiacover_v1.233dda8f.webp";